import { makeStyles, Box, Hidden } from "@material-ui/core";
import TagNewPicto from "ui/StateTag/assets/new-desktop.svg";
import TagSecondHandPicto from "ui/StateTag/assets/reco-desktop.svg";
import TagNewPictoSmall from "ui/StateTag/assets/new-mobile.svg";
import TagSecondHandPictoSmall from "ui/StateTag/assets/reco-mobile.svg";

export const ProductStateTag = ({ isStateNew }) => {
  const classes = useStyle();

  return (
    <>
      <Hidden implementation="css" mdUp>
        <Box className={classes.tagContainer}>{isStateNew ? TagNewPictoSmall : TagSecondHandPictoSmall}</Box>
      </Hidden>
      <Hidden implementation="css" smDown>
        <Box className={classes.tagContainer}>{isStateNew ? TagNewPicto : TagSecondHandPicto}</Box>
      </Hidden>
    </>
  );
};

const useStyle = makeStyles(() => ({
  tagContainer: {
    display: "flex",
    position: "relative",
    zIndex: 1,
  },
}));
